import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Button, Row, Col } from 'react-bootstrap'
import { formInput } from './formInput'
import { schema } from './validationSchema'
import { CommonForm, toastState } from 'src/views/components'
import { i18nTranslate } from 'src/utils'
import { accountsContainer, customerContainer } from 'src/models'
import { getLocaleCodeFromUrl } from 'src/utils/localeUtils'
import { GoogleCaptcha } from 'src/views/components/GoogleCaptcha'
import { getGoogleCaptchaToken } from 'src/views/components/GoogleCaptcha'
import { APPConfig, convertToBoolean } from 'config/appConfig'
import { trackGTMEvents, getAccountTypes } from 'src/utils'
import { checkIfReEnroll } from '../../Header/deps'
import { parsePhoneNumberField } from 'src/utils/signUpUtils'
import './styles.scss'

@observer
class VerifyPhoneNumber extends Component {
  @observable isErrors = false
  constructor(props) {
    super(props)

    this.state = {
      btnDisabled: false,
    }
  }

  handleSubmit = async formData => {
    this.setState({ btnDisabled: true })
    const googleCaptchaId = APPConfig.getAppConfig()?.googleCaptchaId || ''
    const enableGoogleCaptcha =
      convertToBoolean(APPConfig.getAppConfig()?.enableGoogleCaptcha) || false
    const phoneNumber = await this.props.profileSetPhoneNumber()
    const initialPrefillData = this.props.parsedPhoneDataFromProfileResponse
    let localValue = getLocaleCodeFromUrl() || ''
    localValue = localValue?.toLowerCase()?.split('_')
    const marketRegion = localValue?.[1]?.toUpperCase() || 'US'
    const locale = localValue?.[0] || 'en'

    let token = ''
    if (enableGoogleCaptcha) {
      token = await getGoogleCaptchaToken({ googleCaptchaId })
    }

    let sendCodeResponse = 'noResponse'
    const sendCodeResponseCbk = async () => {
      sendCodeResponse = await accountsContainer.sendPhoneVerificationCode(
        phoneNumber,
        locale,
        token
      )
      if (accountsContainer.isSuccessResponse(sendCodeResponse)) return

      const defaultMessage = i18nTranslate(
        'verifyPhone.updateFailure',
        'Something went wrong, please try again'
      )
      const landlineMessage = i18nTranslate(
        'verifyPhone.landlinePhoneFailure',
        'SMS is not supported by landline phone number'
      )
      const captchaFailedMessage = i18nTranslate(
        'captcha_error_suspicious_activity',
        'Captcha failed due to suspicious user activity, please try again later'
      )
      const tooManyRequestsMessage = i18nTranslate(
        'error_too_many_invalid_number_requests',
        'You’ve sent too many requests for invalid number. Please wait a moment and try again later'
      )

      let toastMessage = defaultMessage

      if (sendCodeResponse?.statusCode === 400) {
        const { code, message } = sendCodeResponse
        if (code === 'ACCMOBVER101') {
          toastMessage = landlineMessage
        } else if (code === 'ACCMOBVER001') {
          toastMessage = captchaFailedMessage
        }
      } else if (sendCodeResponse?.statusCode === 429) {
        toastMessage = tooManyRequestsMessage
      } else {
        toastMessage = defaultMessage
      }

      toastState.setToastMessage(toastMessage, false)
    }

    // console.log(
    //   'phone verify compare',
    //   JSON.stringify(initialPrefillData || {}),
    //   JSON.stringify(customerContainer?.setVerifyPhone || {})
    // )
    const normalizePhone = async (number, countryCode) => {
      const parsed = await parsePhoneNumberField(number, countryCode)
      return parsed?.number || ''
    }
    let isSameAsCurrentProfilePhone = false
    const isSameCountryCode =
      initialPrefillData?.phoneCountryCode ===
      customerContainer?.setVerifyPhone?.phoneCountryCode
    const isSamePhoneNumber =
      initialPrefillData?.phoneNumber ===
      customerContainer?.setVerifyPhone?.phoneNumber
    const isEmptyPhoneAndCountryCode =
      !customerContainer?.setVerifyPhone?.phoneNumber &&
      !customerContainer?.setVerifyPhone?.phoneCountryCode
    let isSameAfterNormalizing = false
    try {
      if (
        initialPrefillData?.phoneNumber &&
        initialPrefillData?.phoneCountryCode &&
        customerContainer?.setVerifyPhone?.phoneNumber &&
        customerContainer?.setVerifyPhone?.phoneCountryCode
      ) {
        const normalizedProfilePhone = await normalizePhone(
          initialPrefillData?.phoneNumber,
          initialPrefillData?.phoneCountryCode
        )
        const normalizedCurrentInputPhone = await normalizePhone(
          customerContainer?.setVerifyPhone?.phoneNumber,
          customerContainer?.setVerifyPhone?.phoneCountryCode
        )
        isSameAfterNormalizing =
          normalizedProfilePhone === normalizedCurrentInputPhone
      }
    } catch (e) {
      console.error('Error normalizing phone numbers', e)
    }
    // when user doesn't modify the input
    // (isSameCountryCode && isSamePhoneNumber) is sufficient

    // but when user modifies the input, format gets updated with spaces and brackets
    // hence normalizing and checking with isSameAfterNormalizing
    if (
      isEmptyPhoneAndCountryCode ||
      (isSameCountryCode && isSamePhoneNumber) ||
      isSameAfterNormalizing
    ) {
      await sendCodeResponseCbk()
    } else {
      const response = await accountsContainer.checkPhoneNumberUniqueness(
        phoneNumber,
        marketRegion
      )
      if (response?.data?.checkPhoneNumberUniqueness?.isUnique === true) {
        await sendCodeResponseCbk()
      } else if (
        response?.data?.checkPhoneNumberUniqueness?.isUnique === false
      ) {
        this.isErrors = true
      } else {
        const defaultMessage = i18nTranslate(
          'verifyPhone.updateFailure',
          'Something went wrong, please try again'
        )
        toastState.setToastMessage(response?.message || defaultMessage, false)
      }
    }

    const { currentAccountType, convertingAccountType } = getAccountTypes(
      accountsContainer,
      customerContainer
    )

    if (
      !this.isErrors &&
      accountsContainer.isSuccessResponse(sendCodeResponse) &&
      sendCodeResponse !== 'noResponse'
    ) {
      this.props.setPageToShow('codeVerify')
      if (this?.props?.isDownConvertPhoneVerify) {
        trackGTMEvents({
          event: 'account phone verify',
          account_type: 'BA to Member',
          phone_verify: 'verified',
          platform: 'equinox',
        })
      } else {
        trackGTMEvents({
          event: 'account phone verify',
          account_type: `${currentAccountType} to ${convertingAccountType}`,
          phone_verify: 'verified',
        })
      }
    }
    this.setState({ btnDisabled: false })
  }

  renderSubmitButton = () => {
    return (
      <>
        <Row className="">
          <Col className="">
            <Button
              variant="primary"
              className="confirm-btn w-100 mt-2"
              data-testid="qa-continue-btn"
              size={'md'}
              type="submit"
              disabled={this.state.btnDisabled}>
              {i18nTranslate('accountProfile.continueButton', 'Continue')}
            </Button>
          </Col>
        </Row>
        {this?.props?.isFromFourMonthNotification ? (
          <Row>
            <Col className="">
              <Button
                className="confirm-btn w-100 mt-2"
                data-testid="qa-nevermind-btn"
                size={'md'}
                variant="outline-primary"
                type="submit"
                onClick={this?.props?.handleNeverMindDoItLater}>
                {i18nTranslate(
                  'ba_to_member_dismiss_message',
                  "Nevermind, I'll do this later"
                )}
              </Button>
            </Col>
          </Row>
        ) : this.props?.verifyPhoneBasedOnReEnroll ? (
          <Row>
            <Col className="">
              <Button
                className="confirm-btn w-100 mt-2"
                data-testid="qa-nevermind-btn"
                size={'md'}
                variant="outline-primary"
                type="submit"
                onClick={this?.props?.handleNeverMindSignOut}>
                {i18nTranslate(
                  'ba_to_member_sign_out_text',
                  'Never mind, Sign me out'
                )}
              </Button>
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </>
    )
  }
  hideError = () => {
    this.isErrors = false
  }

  render() {
    const enableGoogleCaptcha =
      convertToBoolean(APPConfig.getAppConfig()?.enableGoogleCaptcha) || false
    return (
      <div className={`verifyNumber ${checkIfReEnroll() ? 'pt-3' : ''}`}>
        <h2 className="verify-number-heading pt-0 px-3">
          {i18nTranslate('phoneVerifyText', 'Please verify your phone number!')}
        </h2>
        {this?.props?.isDownConvertPhoneVerify ? (
          <p className="description-text">
            {i18nTranslate(
              'ba_to_member_phone_number_verify_description',
              'This is needed to change your account online'
            )}
          </p>
        ) : this?.props?.isFromFourMonthNotification ? (
          <p className="confirm-text">
            {i18nTranslate(
              'ba_to_member_identity_verification_message',
              'This is needed to verify your identity in order to switch to a Member Account'
            )}
          </p>
        ) : this?.props?.invitationType === 'MEMBER' ? (
          <p className="Reenroll-confirm-text">
            {i18nTranslate(
              'ba_to_member_re_enroll_identity_verification',
              'This is needed to verify your identity in order to Re-Enroll as a Member'
            )}
          </p>
        ) : this?.props?.invitationType === 'BRAND_AFFILIATE' ? (
          <p className="Reenroll-confirm-text">
            {i18nTranslate(
              'ba_to_member_brand_affiliate_re_enroll_verification',
              'This is needed to verify your identity in order to Re-Enroll as a Brand Affiliate'
            )}
          </p>
        ) : (
          <p className="confirm-text">
            {i18nTranslate('phoneNoVerify.continue', 'Confirm or make changes')}
          </p>
        )}
        <CommonForm
          classNameValue={{
            formRowClassName: 'verify-phone-number-form',
          }}
          formTypeJson={formInput(
            this.isErrors,
            this.hideError,
            this.props.parsedPhoneDataFromProfileResponse
          )}
          schema={schema()}
          SubmitButtonProps={this.renderSubmitButton}
          hasInlineSubmitButton={false}
          onSubmit={this.handleSubmit}
        />
        {enableGoogleCaptcha && <GoogleCaptcha />}
      </div>
    )
  }
}

export default VerifyPhoneNumber
export { VerifyPhoneNumber }
